export const currency = {
    UAH: '₴',
    EUR: '€',
    USD: '$',
    PLN: 'zł.',
}